module.exports = __webpack_public_path__ + "img/044.a0b03b32.png";